import { render, staticRenderFns } from "./sfc.vue?vue&type=template&id=ec597fe2&scoped=true&"
import script from "./sfc.vue?vue&type=script&lang=js&"
export * from "./sfc.vue?vue&type=script&lang=js&"
import style0 from "./sfc.vue?vue&type=style&index=0&id=ec597fe2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec597fe2",
  null
  
)

export default component.exports